export const defaultAuthData = {
  status: "initial",
  message: "",
  isTokenPresent: false,
  isTokenValid: false,
  isAuthenticated: false,
  metadata: {
    name: "Demo User",
    preferred_username: "demo.user@abc.com",
    role: "user",
  },
};

export const defaultAccountSetupValue = {
  geography: [],
  jobRole: "",
  functions: "",
};

export const storeData = {
  auth: defaultAuthData,
  accountSetup: defaultAccountSetupValue,
};
